import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  useToast,
  Circle,
  Link,
  Progress
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useRef, useState } from "react";
import { ReactComponent as AddPhoto } from "../../svg/AddPhoto.svg";
import Tags from "../common/Tags";
import { useDispatch, useSelector } from "react-redux";
import { resetFormStatus, selectedMenu, setHeaderText } from "../../redux/actions/actions";
import { useHistory } from "react-router-dom";
import {
  getWebexTokens,
  setWebexTokens,
  submitLiveCourseForm,
} from "../../redux/api_calls/apiCalls";

import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import JoditEditor from "jodit-react";

export default function CustomAddLiveCourse() {
  const [courseImage, setCourseImage] = useState(null);
  const [courseImageUrl, setCourseImageUrl] = useState(null);
  const [keywordTags, setKeywordTags] = useState([]);
  const [courseImageError, setCourseImageError] = useState(null);
  const [courseNameError, setCourseNameError] = useState(null);
  const [descriptionError, setDescriptionError] = useState(null);
  const [startDateError, setStartDateError] = useState(null);
  const [startTimeError, setStartTimeError] = useState(null);
  const [durationError, setDurationError] = useState(null)
  const [keywordsError, setKeywordsError] = useState(null);
  const [startTime, setStartTime] = useState('')
  const [startDate, setStartDate] = useState('')
  const courseNameRef = useRef();
  const durationRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const toast = useToast();

  const formStatus = useSelector((state) => state.formStatus);
  const headerText = useSelector((state) => state.headerState.headerText);

  // const [gettingAccessToken, setGettingAccessToken] = useState(false)
  const slider = useSelector(state => state.sliderState.sliderOpen)
  // const accessToken = useSelector(state => state.accessTokenState)
  const { tokens, isLoading } = useSelector(state => state.webexTokenState)
  const user = JSON.parse(window.localStorage.getItem("user")) ? JSON.parse(window.localStorage.getItem("user")).user : null

  const editor = useRef(null)
  const [content, setContent] = useState('')

  const getAccessToken = async (code) => {
    try {
      let response = await fetch('https://webexapis.com/v1/access_token?client_id=Cab35d58ec1973764ce127fbb5b3d8f28475061cc367af8b6987acb2efd206dc0&grant_type=authorization_code&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fadd-live-courses&scope=spark%3Aall%20spark%3Akms&client_secret=d446138322c8a32b5d074573dd8ea3c0d7bea6fbae6f9a44fa1be6c57a207dad&code=' + code, { method: 'POST', headers: { 'content-type': 'application/x-www-form-urlencoded' } })
      let data = await response.json()
      dispatch(setWebexTokens(user.id, data))
    }
    catch (error) {
      console.log(error.message)
    }
  }

  // useEffect(() => {
  //   if (accessToken) {
  //     setGettingAccessToken(false)
  //   }
  // }, [accessToken])

  useEffect(() => {
    dispatch(getWebexTokens(user.id))
    if (window.location.href.includes('code')) {
      let equalIndex = window.location.href.indexOf('=')
      let lastAnd = window.location.href.lastIndexOf('&')
      let code = window.location.href.substring(equalIndex + 1, lastAnd)
      getAccessToken(code)
    }
    // eslint-disable-next-line
  }, [])

  function validateCourseName() {
    let courseName = courseNameRef.current.value.trim();
    if (!courseName.length) {
      setCourseNameError("Live Session Name is required");
      return true;
    } else {
      setCourseNameError(null);
      return false;
    }
  }

  function validateDescription() {
    let description = content;
    if (!description.length) {
      setDescriptionError("Agenda description is required");
      return true;
    } else {
      setDescriptionError(null);
      return false;
    }
  }

  function validateStartDate() {
    let error;
    let date = new Date(Date.now())
    let month = Number(date.getMonth()) + 1
    let day = Number(date.getDate())
    let today = date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    if (!startDate.length) {
      error = "Session Start Date is required";
    } else if (Date.parse(startDate.split('-').reverse().join('-')) < Date.parse(today)) {
      error = "Session Start Date cannot be less than today!";
    }
    if (error) {
      setStartDateError(error);
      return true;
    } else {
      setStartDateError(null);
      return false;
    }
  }

  function validateKeyword() {
    if (!keywordTags.length) {
      setKeywordsError("No Keyword Entered");
      return true;
    } else {
      setKeywordsError(null);
      return false;
    }
  }

  function validatePhoto() {
    if (!courseImage) {
      setCourseImageError("Please select a Cover Photo for the Session!");
      return true;
    } else {
      setCourseImageError(null);
      return false;
    }
  }

  function keywordKeyPressHandler(e) {
    e.stopPropagation();
    if (e.key === "Enter" || e.key === "ENTER") {
      let currentKeyword = e.target.value.trim();
      if (currentKeyword.length) {
        let tempTags = [...keywordTags];
        tempTags.push(currentKeyword);
        setKeywordTags(tempTags);
        e.target.value = "";
        return false;
      }
    }
  }


  function validateDuration() {
    let duration = durationRef.current.value.trim()
    if (!duration.length) {
      setDurationError('Duration cannot be left empty!')
      return true
    }
    else if (Number(duration) < 40) {
      setDurationError('Please enter a value greater than or equal to 40')
      return true
    }
    else if (duration.includes('.')) {
      setDurationError('Duration cannot contain a decimal value!')
      return true
    }
    else if (Number(duration) > 180) {
      setDurationError('Duration cannot be more than 180 minutes')
      return true
    }
    else {
      setDurationError(null)
      return false
    }
  }

  function validateStartTime() {
    let selectedTime = startTime.split(":")
    let date = new Date(Date.now())
    let month = (Number(date.getMonth()) + 1)
    let day = date.getDate()
    let today = date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    let currentHour = new Date().getHours()
    let currentMinutes = new Date().getMinutes()
    if (!startTime.length) {
      setStartTimeError("Start Time is required!")
      return true
    }
    else if ((startDate === today && Number(selectedTime[0]) < Number(currentHour)) || (startDate === today && Number(selectedTime[0]) === Number(currentHour) && Number(selectedTime[1]) < Number(currentMinutes))) {
      setStartTimeError("Start Time cannot be less than current time!")
      return true
    }
    else if (startDate === today && selectedTime[0] === currentHour && selectedTime[1] === currentMinutes) {
      setStartTimeError("Start Time cannot be equal to current time!")
      return true
    }
    else {
      setStartTimeError(null)
      return false
    }
  }

  const validateFields = () => {
    return (
      validatePhoto() ||
      validateCourseName() ||
      validateStartDate() ||
      validateStartTime() ||
      validateDuration() ||
      validateDescription() ||
      validateKeyword()
    );
  };

  function removeTagHandler(keyword) {
    setKeywordTags(keywordTags.filter((tag) => tag !== keyword));
  }

  const cancelHandler = () => {
    history.push("/live-courses");
  };

  const resetForm = () => {
    setCourseImage(null);
    setCourseImageUrl(null)
    courseNameRef.current.value = "";
    setStartDate('')
    setStartTime('')
    setContent("");
    setKeywordTags([]);
  };

  useEffect(() => { }, [courseImageError]);

  useEffect(() => {
    dispatch(setHeaderText("Add Live Session"));
    dispatch(selectedMenu(4))
    return () => {
      dispatch(resetFormStatus())
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (formStatus.success && !formStatus.error) {
      toast({
        title: "Session Added Successfully!",
        description: "Session Added!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      resetForm();
      history.push("/live-courses");
    } else if (formStatus.error) {
      toast({
        title: "Something went wrong!",
        description: "Error!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    // eslint-disable-next-line
  }, [formStatus.success, formStatus.error]);

  const convertToMinutes = (time) => {
    let timeArray = time.split(":")
    return Number(timeArray[0]) * 60 + Number(timeArray[1])
  }

  const convertToHours = (minutes) => {
    return Math.floor(minutes / 60) + ":" + minutes % 60
  }

  const addNewLiveCourse = () => {
    let endDate = startDate
    let endTime = convertToHours(convertToMinutes(startTime) + Number(durationRef.current.value.trim()))
    let endTimeArray = endTime.split(":")
    if (endTimeArray[0] >= 24) {
      endTimeArray[0] = Number(endTimeArray[0]) - 24
      let newEndDate = new Date(Date.parse(startDate) + 86400000)
      let year = newEndDate.getFullYear()
      let month = (Number(newEndDate.getMonth()) + 1)
      let day = newEndDate.getDate()
      endDate = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    }
    let meetingData = {
      title: courseNameRef.current.value.trim(),
      agenda: content,
      password: "T3st@3nd",
      start: new Date(startDate.split('-').reverse().join('-') + " " + startTime).toJSON(),
      end: new Date(endDate.split('-').reverse().join('-') + " " + endTimeArray.join(":")).toJSON(),
      enabledAutoRecordMeeting: false,
      allowAnyUserToBeCoHost: false,
      enabledJoinBeforeHost: false,
      enableConnectAudioBeforeHost: false,
      joinBeforeHostMinutes: 0,
      excludePassword: false,
      publicMeeting: false,
      allowFirstUserToBeCoHost: false,
      allowAuthenticatedDevices: false,
      sendEmail: true,
      // hostEmail: "mr.mash@gmail.com",
    }
    let keywords = keywordTags.join(' ,')

    console.log(meetingData)
    dispatch(submitLiveCourseForm(meetingData, tokens, courseImage, keywords));
    /*
    {
  "enabledAutoRecordMeeting": false,
  "allowAnyUserToBeCoHost": false,
  "enabledJoinBeforeHost": false,
  "enableConnectAudioBeforeHost": false,
  "excludePassword": false,
  "publicMeeting": false,
  "enableAutomaticLock": false,
  "allowFirstUserToBeCoHost": false,
  "allowAuthenticatedDevices": false,
  "sendEmail": true,
  "title": "Test",
  "agenda": "New Meeting",
  "password": "T3st@3nd",
  "start": "2021-09-19T07:35:00.000Z",
  "end": "2021-09-19T09:35:00.000Z",
  "joinBeforeHostMinutes": "0",
  "hostEmail": "mr.mash@gmail.com"
    */
  };

  const submitHandler = () => {
    if (validateFields()) {
      return;
    } else {
      addNewLiveCourse();
    }
  };

  useEffect(() => {
    if (courseImage) {
      if (typeof courseImage === "object") {
        let extension = courseImage.name.substring(
          courseImage.name.lastIndexOf(".") + 1
        );
        let acceptedExtensions = ["jpeg", "jpg", "png"];
        if (!acceptedExtensions.includes(extension.toLowerCase())) {
          setCourseImageError("Invalid file type");
          setCourseImageUrl(null)
          setCourseImage(null);
        }
        else if ((courseImage.size / (1024 * 1024)) > 0.5) {
          setCourseImageError("Please upload files of size less than or equal to 512 kb!");
          setCourseImageUrl(null)
          setCourseImage(null);
        }
        else {
          setCourseImageUrl(URL.createObjectURL(courseImage))
        }
      }
    }
  }, [courseImage]);

  return (
    <Box
      flexGrow="1"
      d="flex"
      justifyContent="flex-start"
      alignItems="center"
      flexDirection="column"
      minH="90vh"
      pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
      transition='all 350ms ease'
    >
      <Box
        width={["95%", "95%", "90%", "85%"]}
        justifyContent={["center", "center", "flex-start", "flex-start"]}
        alignItems={["center", "center", "flex-start", "flex-start"]}
        d="flex"
        mb="2rem"
        flexDirection="column"
      >
        <Text
          fontSize={["20px", "25px", "30px", "40px"]}
          d={["none", "none", "none", "flex"]}
          fontWeight="900"
          style={{ fontFamily: "Mulish, sans-serif" }}
          mb="2rem"
        >
          {headerText}
        </Text>
        <Box
          width={["100%", "100%", "100%", "85%"]}
          justifyContent={["center", "center", "flex-start", "flex-start"]}
          alignItems={["center", "center", "flex-start", "flex-start"]}
          d="flex"
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              width: "90%",
            }}
            pointerEvents={formStatus.isSubmitting ? 'none' : 'all'}
          >
            {
              isLoading ?
                <Progress isIndeterminate size='xs' width='100%' />
                :
                <>
                  {
                    !tokens ?
                      <Link style={{ textDecoration: 'none' }} href="https://webexapis.com/v1/authorize?client_id=Cab35d58ec1973764ce127fbb5b3d8f28475061cc367af8b6987acb2efd206dc0&response_type=code&redirect_uri=https%3A%2F%2Fwizardly-liskov-b2a03b.netlify.app%2Fadd-live-courses&scope=meeting%3Arecordings_read%20meeting%3Aadmin_preferences_write%20meeting%3Aadmin_schedule_write%20meeting%3Aadmin_preferences_read%20meeting%3Aschedules_read%20meeting%3Aparticipants_read%20meeting%3Aadmin_participants_read%20meeting%3Apreferences_write%20meeting%3Arecordings_write%20meeting%3Apreferences_read%20meeting%3Aadmin_recordings_read%20meeting%3Atranscripts_read%20meeting%3Aschedules_write%20spark%3Akms%20meeting%3Acontrols_write%20meeting%3Aadmin_recordings_write%20meeting%3Acontrols_read%20meeting%3Aparticipants_write%20meeting%3Aadmin_schedule_read%20meeting%3Aadmin_transcripts_read&state=UnicornsAreReal">
                        <Button colorScheme="facebook">Get Access Token</Button>
                      </Link>
                      :
                      <>
                        <FormControl isInvalid={courseImageError}>
                          <FormLabel
                            variant="custom"
                            htmlFor="add_photo"
                            style={{ fontFamily: "Mulish, sans-serif" }}
                          >
                            Cover Image
                          </FormLabel>

                          <Box width="140px" id="add_photo" mr='5rem' position='relative'>
                            <label htmlFor="add_photo_helper">
                              <Button
                                as="span"
                                width="140px"
                                height="140px"
                                bg="white"
                                bgImage={courseImageUrl ? courseImageUrl : null}
                                bgRepeat='no-repeat'
                                bgSize='cover'
                                bgPosition='center'
                                borderRadius="xl"
                                fontWeight="800"
                                fontSize={["12px", "14px", "16px", "18px"]}
                                style={{ fontFamily: "Mulish, sans-serif" }}
                                color="#E4B716"
                                _hover={{ bg: "white", bgImage: courseImageUrl ? courseImageUrl : null, bgRepeat: 'no-repeat', bgSize: 'cover', bgPosition: 'center' }}
                                d="flex"
                                flexDir="column"
                                border="1px solid rgba(0, 0, 0, 0.1)"
                                cursor="pointer"
                              >
                                {
                                  !courseImageUrl &&
                                  <>
                                    <AddPhoto style={{ marginBottom: "0.5rem" }} />
                                    Add Photo
                                  </>
                                }
                              </Button>
                              {
                                courseImageUrl &&
                                <Circle
                                  size='30px'
                                  bg='white'
                                  position='absolute'
                                  right='-15px'
                                  bottom='10px'
                                  boxShadow='xl'
                                  border="1px solid rgba(0, 0, 0, 0.1)"
                                  cursor='pointer'
                                >
                                  <AddPhoto width='15px' height='15px' />
                                </Circle>
                              }
                            </label>
                            <input
                              accept="image/png, image/jpeg, image/jpg"
                              id="add_photo_helper"
                              name="add_photo_helper"
                              type="file"
                              onChange={(e) => {
                                setCourseImage(e.target.files[0]);
                                setCourseImageError(null);
                              }}
                              style={{ display: "none" }}
                            />
                          </Box>
                          <FormErrorMessage fontSize="sm">
                            {courseImageError}
                          </FormErrorMessage>
                          {courseImage && (
                            <Text
                              mt="1"
                              fontWeight="600"
                              color="#666666"
                              style={{ fontFamily: "Mulish, sans-serif" }}
                              fontSize="md"
                            >
                              Attached file :
                              <span style={{ fontSize: "13px", marginLeft: '1em' }}>
                                <em>{courseImage.name ? `${courseImage.name} - ${(courseImage.size / (1024 * 1024)).toFixed(2)} MB` : courseImage}</em>
                              </span>
                            </Text>
                          )}
                        </FormControl>

                        <FormControl isInvalid={courseNameError}>
                          <FormLabel
                            variant="custom"
                            htmlFor="course_name"
                            style={{ fontFamily: "Mulish, sans-serif" }}
                          >
                            Session Name
                          </FormLabel>
                          <Input
                            id="course_name"
                            width={["100%", "100%", "90%", "85%"]}
                            bgColor="white"
                            ref={courseNameRef}
                            border='1px solid rgba(0, 0, 0, 0.1)'
                            borderRadius="13px"
                            height='40px'
                            onChange={() => {
                              if (courseNameRef.current.value.trim().length > 0) {
                                setCourseNameError(null);
                              }
                            }}
                          />
                          <FormErrorMessage fontSize="sm">
                            {courseNameError}
                          </FormErrorMessage>
                        </FormControl>

                        <Box
                          width={["100%", "100%", "90%", "85%"]}
                          d="flex"
                          justifyContent="space-between"
                        >
                          <Box width="45%">
                            <FormControl isInvalid={startDateError}>
                              <FormLabel
                                variant="custom"
                                htmlFor="start_date"
                                style={{ fontFamily: "Mulish, sans-serif" }}
                              >
                                Start Date
                              </FormLabel>

                              <Flatpickr
                                value={startDate}
                                options={
                                  { dateFormat: 'd-m-Y' }
                                }
                                placeholder='dd-mm-yyyy'
                                onChange={(date, dateStr) => {
                                  setStartDate(dateStr)
                                  setStartDateError(null)
                                }}
                                style={{ padding: '1rem', color: '#666666', width: '100%', height: '40px', backgroundColor: 'white', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                              />

                              <FormErrorMessage fontSize="sm">
                                {startDateError}
                              </FormErrorMessage>
                            </FormControl>
                          </Box>
                          <Box width="45%">
                            <FormControl isInvalid={startTimeError}>
                              <FormLabel
                                variant="custom"
                                htmlFor="end_date"
                                style={{ fontFamily: "Mulish, sans-serif" }}
                              >
                                Start Time
                              </FormLabel>

                              <Flatpickr
                                value={startTime}
                                options={
                                  {
                                    enableTime: true,
                                    noCalendar: true,
                                    dateFormat: "H:i",
                                    time_24hr: true
                                  }
                                }
                                placeholder='hh:mm'
                                onChange={(date, dateStr) => {
                                  setStartTime(dateStr)
                                  setStartTimeError(null)
                                }}
                                style={{ padding: '1rem', color: '#666666', width: '100%', height: '40px', backgroundColor: 'white', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                              />
                              <FormErrorMessage fontSize="sm">
                                {startTimeError}
                              </FormErrorMessage>
                            </FormControl>
                          </Box>
                        </Box>

                        <Box
                          width={["100%", "100%", "90%", "85%"]}
                          d="flex"
                          justifyContent="space-between"
                        >
                          <Box width="45%">
                            <FormControl isInvalid={durationError}>
                              <FormLabel
                                variant="custom"
                                htmlFor="start_date"
                                style={{ fontFamily: "Mulish, sans-serif" }}
                              >
                                Duration (in Minutes)
                              </FormLabel>
                              <Input
                                type="number"
                                color="#666666"
                                id="duration"
                                width="100%"
                                border='1px solid rgba(0, 0, 0, 0.1)'
                                borderRadius="13px"
                                height='40px'
                                bgColor="white"
                                ref={durationRef}
                                onChange={() => {
                                  if (durationRef.current.value.trim().length > 0) {
                                    setDurationError(null);
                                  }
                                }}
                                fontSize={["9px", "11px", "13px", "16px"]}
                              />
                              <FormErrorMessage fontSize="sm">
                                {durationError}
                              </FormErrorMessage>
                            </FormControl>
                          </Box>
                        </Box>

                        <FormControl isInvalid={descriptionError}>
                          <FormLabel
                            variant="custom"
                            htmlFor="course_description"
                            style={{ fontFamily: "Mulish, sans-serif" }}
                          >
                            Session Agenda
                          </FormLabel>
                          <Box width={["100%", "100%", "90%", "85%"]} bg='white' borderRadius='13px' minH='200px' >
                            <JoditEditor
                              ref={editor}
                              value={content}
                              config={{
                                readOnly: false,
                                uploader: { url: 'none' },
                                removeButtons: ["image", "video", "file", "table", "fullsize", "link", "find"],
                                disablePlugins: ["image-properties", "image-processor", "image", "video", "media", "file", "table", "class-span", "resize-cells", "select-cells", "table-keyboard-navigation", "print", "preview", "fullsize", "search", "link"],
                              }}
                              tabIndex={1} // tabIndex of textarea
                              onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                              onChange={newContent => { }}
                            />
                          </Box>
                          <FormErrorMessage fontSize="sm">
                            {descriptionError}
                          </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={keywordsError} onSubmit={() => false}>
                          <FormLabel
                            variant="custom"
                            htmlFor="keywords"
                            style={{ fontFamily: "Mulish, sans-serif" }}
                          >
                            Keywords
                          </FormLabel>
                          <Box
                            d="flex"
                            bgColor="white"
                            width={["100%", "100%", "90%", "85%"]}
                            p="1"
                            border='1px solid rgba(0, 0, 0, 0.1)'
                            borderRadius="13px"
                            minHeight='59px'
                            flexWrap="wrap"
                          >
                            <Box
                              d={keywordTags.length > 0 ? "flex" : "none"}
                              justifyContent="flex-start"
                              flexWrap="wrap"
                            >
                              {keywordTags.length > 0 &&
                                keywordTags.map((tag, idx) => (
                                  <Tags
                                    keyword={tag}
                                    removeTag={removeTagHandler}
                                    key={idx}
                                  />
                                ))}
                            </Box>
                            <Input
                              id="keywords"
                              bgColor="white"
                              placeholder="Enter Keyword"
                              onKeyDown={keywordKeyPressHandler}
                              border="none"
                              outline="none"
                              p="5px"
                              minW="40%"
                              focusBorderColor="none"
                              style={{ fontFamily: "Mulish, sans-serif" }}
                              fontWeight="600"
                              fontSize="16px"
                              onChange={() => setKeywordsError(null)}
                              height='100%'
                              color='#999999'
                            />
                          </Box>
                          <FormErrorMessage fontSize="sm">{keywordsError}</FormErrorMessage>
                        </FormControl>

                        <Box
                          width={["100%", "100%", "90%", "85%"]}
                          d="flex"
                          flexDir={["column", "column", "row", "row"]}
                          justifyContent={["center", "center", "flex-start", "flex-start"]}
                          mt="2rem"
                        >
                          <Button
                            bgColor="#fd5f3a"
                            color="white"
                            borderRadius="lg"
                            p={["6px 15px", "8px 20px", "12px 30px"]}
                            _hover={{ bg: "#fd6f4c" }}
                            isLoading={formStatus.isSubmitting}
                            loadingText="Adding..."
                            onClick={submitHandler}
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="800"
                            fontSize={["13px", "14px", "16px"]}
                            mr={["0", "0", "20px", "20px"]}
                            mb={["20px", "20px", "0", "0"]}
                          >
                            Add Live Session
                          </Button>
                          <Button
                            bgColor="white"
                            color="#999999"
                            borderRadius="lg"
                            border="1px solid rgba(0, 0, 0, 0.2)"
                            p={["6px 15px", "8px 20px", "12px 30px"]}
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="800"
                            fontSize={["13px", "14px", "16px"]}
                            onClick={cancelHandler}
                          >
                            Cancel
                          </Button>
                        </Box>
                        {formStatus.error && (
                          <Text
                            fontSize="sm"
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            color="red.500"
                          >
                            {formStatus.error}
                          </Text>
                        )}
                      </>
                  }
                </>
            }
          </Box>

        </Box>
      </Box>
    </Box>
  );
}



/*
Client Id: Cab35d58ec1973764ce127fbb5b3d8f28475061cc367af8b6987acb2efd206dc0
Client Secret : d446138322c8a32b5d074573dd8ea3c0d7bea6fbae6f9a44fa1be6c57a207dad
Auth URL : https://webexapis.com/v1/authorize?client_id=Cab35d58ec1973764ce127fbb5b3d8f28475061cc367af8b6987acb2efd206dc0&response_type=code&redirect_uri=https%3A%2F%2Fwizardly-liskov-b2a03b.netlify.app%2Fadd-live-courses&scope=spark%3Akms%20spark%3Aall&state=set_state_here
Integration id: Y2lzY29zcGFyazovL3VzL0FQUExJQ0FUSU9OL0NhYjM1ZDU4ZWMxOTczNzY0Y2UxMjdmYmI1YjNkOGYyODQ3NTA2MWNjMzY3YWY4YjY5ODdhY2IyZWZkMjA2ZGMw

*/